import React, { useState } from "react";
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import validator from "validator";
import { login } from "../../services/AuthServices";
import Utils from "../../utils";
import { authActions } from "../../store";
import useSeo from "../../utils/useSeo";
import "../../asset/style/auth.css";

const Login = () => {
  let errorsObj = { email: "", password: "" };
  const [errors, setErrors] = useState(errorsObj);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);

  useSeo({
    title: "Entrar na Plataforma",
    description:
      "Aceda à sua conta TP Software para gerir veículos, inventário, peças e vendas. Plataforma segura para centros de abate automóvel.",
    path: "/login",
    noindex: true,
  });

  const onLogin = (e) => {
    e.preventDefault();
    let errorObj = { ...errorsObj };
    let error = false;

    if (!email) {
      errorObj.email = "Email address is required";
      error = true;
    } else if (!validator.isEmail(email)) {
      errorObj.email = "Please enter valid email address";
      error = true;
    }
    if (!password) {
      errorObj.password = "Password is required";
      error = true;
    }

    setErrors(errorObj);
    Utils.focusError();
    if (error) return;

    setIsLoading(true);
    login({ email: email.trim(), password })
      .then((response) => {
        let userData = response?.data?.data;
        if (userData) {
          Utils.setDetail(userData);
          dispatch(authActions.login(userData));

          // Se a subscrição do user estiver expirada ou a conta bloqueada,
          // abrir directamente a página de renovação em vez do dashboard.
          const company = userData?.company_details;
          const today = new Date(); today.setHours(0, 0, 0, 0);
          const expDate = company?.subscription_expiry ? new Date(company.subscription_expiry) : null;
          const accountBlocked = company && Number(company.account_status) === 0;
          const subExpired = expDate && !isNaN(expDate.getTime()) && expDate < today;
          const hasSubscription = userData?.subscription_data && Object.keys(userData.subscription_data).length > 0;

          if (accountBlocked || subExpired || !hasSubscription) {
            navigate("/subscription?blocked=1");
          } else {
            navigate("/dashboard");
          }
        }
      })
      .catch((error) => {
        Utils.getErrorMessage(error);
        toast.error(Utils.getErrorMessage(error));
      })
      .finally(() => setIsLoading(false));
  };

  return (
    <div className="tp-auth">
      <div className="tp-auth-left">
        <div className="tp-auth-left-content">
          <img
            src="https://tp.software/libs/images/tpsoftware-green-white.png"
            alt="TP Software"
            className="tp-auth-logo"
          />
          <h1>Gestão inteligente de peças auto.</h1>
          <p>Plataforma completa para centros de desmantelamento.</p>
          <div className="tp-auth-stats">
            <div><strong>+30</strong><span>Centros</span></div>
            <div><strong>+1M</strong><span>Peças</span></div>
            <div><strong>25K</strong><span>Viaturas</span></div>
          </div>
        </div>
      </div>

      <div className="tp-auth-right">
        <div className="tp-auth-card">
          <h2>Entrar na conta</h2>
          <p className="tp-auth-sub">Insira as suas credenciais para aceder à plataforma.</p>

          <form onSubmit={onLogin}>
            <div className="tp-auth-field">
              <label>Email</label>
              <input
                type="text"
                placeholder="exemplo@empresa.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className={errors.email ? "tp-auth-input error" : "tp-auth-input"}
              />
              {errors.email && <span className="tp-auth-error">{errors.email}</span>}
            </div>

            <div className="tp-auth-field">
              <label>Palavra-passe</label>
              <input
                type="password"
                placeholder="••••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className={errors.password ? "tp-auth-input error" : "tp-auth-input"}
              />
              {errors.password && <span className="tp-auth-error">{errors.password}</span>}
            </div>

            <div className="tp-auth-forgot">
              <Link to="/forgot-password">Esqueceu a palavra-passe?</Link>
            </div>

            <button type="submit" className="tp-auth-submit" disabled={isLoading}>
              {isLoading ? "A entrar..." : "Entrar"}
            </button>
          </form>

          <div className="tp-auth-footer">
            Não tem conta? <Link to="/signup">Registe-se</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
